import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Button } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    headerMenu: {
      boxShadow: "none",
      backgroundColor: "#4e342e"
    },
    headerProducts: {
      boxShadow: "none",
      backgroundColor: "#ebdcc4"
    },
    menuItem: {
      border: "solid",
      borderRadius: "4px",
      borderColor: "#ebdcc4",
      borderWidth: "thin",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#FFF"
      }
    },
    menuItemLink: {
      fontSize: "12px",
      color: "#000000",
      textDecoration: "none"
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    menuButtonDark: {
      color: "#ffffff",
      border: "0px",
      height: "64px",
      width: "150px",
      borderRadius: "0px"
    },
    menuButtonLightCatalog: {
      color: "#212121",
      backgroundColor: "#ebdcc4",
      border: "0px",
      height: "64px",
      width: "200px",
      borderRadius: "0px"
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    inputRoot: {
      color: 'inherit',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    popoverPaper: {
      width: '100%',
      maxHeight: 'unset',
    },
    cookieLink: {
      color: "#ffffff",
    },
  }),
);

const Footer: React.FC = () => {
  const intl = useIntl();
  const classes = useStyles();
  const cookieName = "RetroCookies";

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
    <CookieConsent
      location="bottom"
      buttonText={intl.formatMessage({ id: "cookie.agree" })}
      cookieName={cookieName}
      style={{ background: "#333333", opacity: "0.95", zIndex: 9999 }}
      buttonStyle={{
        color: "#ffffff",
        backgroundColor: "#4e342e",
        fontSize: "15px",
      }}
      expires={365}
      cookieValue="accepted"
    >
      <FormattedMessage id="cookie.text" />
      &nbsp;
      <Link to="/sikdatnes" className={classes.cookieLink} onClick={scrollToTop}>
        <FormattedMessage id="consent.title" />
      </Link>
      &nbsp; & &nbsp;
      <Link to="/privatuma-politika" className={classes.cookieLink} onClick={scrollToTop}>
        <FormattedMessage id="personData.title" />
      </Link>
    </CookieConsent>
    <AppBar
      color="secondary"
      position="static"
    >
      <Toolbar >
        <Link to="/" onClick={scrollToTop}>
          <img src="/images/logo-footer.png" height="64px" alt={intl.formatMessage({ id: "image.logoAlt" })} />
        </Link>
        <div className={classes.sectionDesktop}>
          <Link to="/product/category/Z2000003657" className={classes.menuItemLink} onClick={scrollToTop}>
            <Button className={classes.menuButtonDark}><FormattedMessage id="nav.catalog" /></Button>
          </Link>
          <Link to="/about" className={classes.menuItemLink} onClick={scrollToTop}>
            <Button className={classes.menuButtonDark}><FormattedMessage id="nav.about" /></Button>
          </Link>
          <Link to="/become-client" className={classes.menuItemLink} onClick={scrollToTop}>
            <Button className={classes.menuButtonDark}><FormattedMessage id="nav.becomeClient" /></Button>
          </Link>
          <Link to="/contacts" className={classes.menuItemLink} onClick={scrollToTop}>
            <Button className={classes.menuButtonDark}><FormattedMessage id="nav.contacts" /></Button>
          </Link>
        </div>
      </Toolbar>
    </AppBar>
    
    </>
  );
};

export default Footer;
